<div *ngIf="coordinatesForm" [formGroup]="coordinatesForm" class="button-wrapper-grid categories">
  <button type="button" class="cnt-button" (click)="setCoordinatesToCurrent()">
    <div class="cnt-button-copy">
      <span class="w-hidden-small w-hidden-tiny">Use My</span>
      Current Location
    </div>
  </button>
  <button type="button" class="cnt-button" (click)="getCoordinatesFromMap()">
    <div class="cnt-button-copy">Find On Map</div>
  </button>

  <div class="left-column-wrapper">
    <label class="title" for="lat">Latitude</label>
    <input
      id="lat"
      type="number"
      min="-90"
      max="90"
      step="0.000001"
      formControlName="lat"
      class="l-lat-text-field w-input"
      name="latitude"
    />
  </div>
  <div class="right-column-wrapper">
    <label class="title" for="lon">Longitude</label>
    <input
      id="lon"
      type="number"
      min="-180"
      max="180"
      step="0.000001"
      formControlName="lon"
      class="l-lat-text-field w-input"
      name="longitude"
    />
  </div>
</div>

<div class="pin-address-outer">
  <a (click)="simpleView = !simpleView" class="link-block w-inline-block">
    <h5>Expand to enter the physical address...</h5>
  </a>

  <div class="pin-address-inner" [ngClass]="{ closed: !simpleView }">
    <div *ngIf="addressForm" [formGroup]="addressForm" class="_3-up-grid categories">
      <div>
        <label class="title" for="address">Street Address</label>
        <input id="address" type="text" formControlName="address" class="text-input w-input" name="address" />
      </div>
      <div>
        <label class="title" for="city">City</label>
        <input id="city" type="text" formControlName="city" class="text-input w-input" name="city" />
      </div>
      <div>
        <label class="title" for="state">State</label>
        <input id="state" type="text" formControlName="state" class="text-input w-input" name="state" />
      </div>
      <div>
        <label class="title" for="zipcode">ZIP Code</label>
        <input id="zipcode" type="text" formControlName="zipcode" class="text-input w-input" name="zipcode" />
      </div>
    </div>
    <p class="fine-print">
      Entering an address here will help us find your coordinates. Ultimately, the GPS coordinates are what CurbNTurfers
      will need.
    </p>
  </div>
</div>
